<template>
  <v-dialog v-model="addRobotConfigDialog" width="850" persistent>
    <v-card class="popup add_store_popup">
      <div>
        <v-btn icon dark x-small class="cornerClose" @click="closeModal">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <div class="popup-titbox d-flex align-center justify-space-between">
          <h3 class="page-title-bar align-start">
            <i class="ico ico-alive-time"></i>{{ $t("Robot Config") }}
          </h3>
        </div>
      </div>
      <div class="row" style="padding: 10px !important">
        <div class="d-flex col-6 align-baseline px-0 py-0 pr-2">
          <v-text-field v-model="company" :label="$t('Company *')" :placeholder="$t('')"
            class="form-input mandatory ml-1 pt-1 pr-2" outlined dense hide-details disabled></v-text-field>
            <v-text-field v-model="storeCode" :label="$t('Store *')" :placeholder="$t('')"
            class="form-input mandatory ml-1 pt-1 pr-2" outlined dense hide-details disabled></v-text-field>
        </div>
      </div>
      <div class="row" style="padding: 10px !important; margin-top: 15px !important;">
        <div class="d-flex col-6 align-baseline px-0 py-0">
          <v-text-field v-model="config.s3Host" :label="$t('S3 Host')" :placeholder="$t('S3 Host')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
        <div class="d-flex col-2 align-baseline px-0 py-0">
          <v-text-field v-model="config.s3Port" :label="$t('S3 Port')" :placeholder="$t('S3 Port')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
      </div>
      <div class="row" style="padding: 10px !important; margin-top: 15px !important;">
        <div class="d-flex col-2 align-baseline px-0 py-0">
          <v-text-field v-model="config.s3Bucket" :label="$t('S3 Bucket')" :placeholder="$t('S3 Bucket')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
        <div class="d-flex col-2 align-baseline px-0 py-0">
          <v-text-field v-model="config.s3Key" :label="$t('S3 Key')" :placeholder="$t('S3 Key')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
        <div class="d-flex col-2 align-baseline px-0 py-0">
          <v-text-field v-model="config.s3Secret" :label="$t('S3 Secret')" :placeholder="$t('S3 Secret')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
      </div>
      <div class="row" style="padding: 10px !important; margin-top: 15px !important;">
        <div class="d-flex col-6 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpHost" :label="$t('AMQP Host')" :placeholder="$t('AMQP Host')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
        <div class="d-flex col-2 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpPort" :label="$t('AMQP Port')" :placeholder="$t('AMQP Port')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
      </div>
      <div class="row" style="padding: 10px !important; margin-top: 15px !important;">
        <div class="d-flex col-3 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpVhost" :label="$t('AMQP Vhost')" :placeholder="$t('AMQP Vhost')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
        <div class="d-flex col-3 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpRouting" :label="$t('AMQP Routing')" :placeholder="$t('AMQP Routing')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
        <div class="d-flex col-3 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpId" :label="$t('AMQP ID')" :placeholder="$t('AMQP ID')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
        <div class="d-flex col-3 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpPw" :label="$t('AMQP PW')" :placeholder="$t('AMQP PW')"
            class="form-input ml-1 pt-1 pr-2" outlined dense hide-details clearable></v-text-field>
        </div>
      </div>
      <div class="row" style="padding: 10px !important; margin-top: 15px !important;">
        <div class="d-flex col-3 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpStatusQueue" :label="$t('AMQP Status Queue')"
            :placeholder="$t('AMQP Status Queue')" class="form-input ml-1 pt-1 pr-2" outlined dense hide-details
            clearable></v-text-field>
        </div>
        <div class="d-flex col-3 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpMissionQueue" :label="$t('AMQP Mission Queue')"
            :placeholder="$t('AMQP Mission Queue')" class="form-input ml-1 pt-1 pr-2" outlined dense hide-details
            clearable></v-text-field>
        </div>
        <div class="d-flex col-3 align-baseline px-0 py-0">
          <v-text-field v-model="config.amqpExchangeMission" :label="$t('AMQP Exchange Mission')"
            :placeholder="$t('AMQP Exchange Mission')" class="form-input ml-1 pt-1 pr-2" outlined dense hide-details
            clearable></v-text-field>
        </div>
      </div>
      <div class="row" style="padding: 10px !important; margin-top: 15px !important;">
        <div class="d-flex col-4 pr-2 align-baseline px-0 py-0">
          <v-file-input dense outlined clearable :label="$t('AMQP Privkey')"
            :placeholder="`${$t('Select AMQP Privkey File')}`" class="form-file fileinput" v-model="amqpPrivkey"
            truncate-length="50" prepend-icon="" append-icon="mdi-file-upload" ref="uploadFile1"
            @click:append="$refs.uploadFile1.$el.querySelector('input').click()"
            @change="onAMQPPrivkeyFileChange"></v-file-input>
        </div>
        <div class="d-flex col-4 pr-2 align-baseline px-0 py-0">
          <v-file-input dense outlined clearable :label="$t('AMQP Cert')"
            :placeholder="`${$t('Select AMQP Cert File')}`" class="form-file fileinput" v-model="amqpCert"
            truncate-length="50" prepend-icon="" append-icon="mdi-file-upload" ref="uploadFile2"
            @click:append="$refs.uploadFile2.$el.querySelector('input').click()"
            @change="onAMQPCertFileChange"></v-file-input>
        </div>
        <div class="d-flex col-4 pr-2 align-baseline px-0 py-0">
          <v-file-input dense outlined clearable :label="$t('AMQP CaCert')"
            :placeholder="`${$t('Select AMQP CaCert File')}`" class="form-file fileinput" v-model="amqpCacert"
            truncate-length="50" prepend-icon="" append-icon="mdi-file-upload" ref="uploadFile3"
            @click:append="$refs.uploadFile3.$el.querySelector('input').click()"
            @change="onAMQPCaCertFileChange"></v-file-input>
        </div>
      </div>
      <v-card-actions class="d-flex" style="justify-content: center;margin-top: 15px !important;">
        <v-btn text icon @click="addRobotConfig" class="btn">Save</v-btn>
        <v-btn text icon @click="closeModal" class="btn">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import codes from '@/plugins/codes'
import EventBus from '@/plugins/eventBus'
export default {
  props: {
    addRobotConfigDialog: {
      type: Boolean,
      default: false
    },
    company: {
      type: String,
      default: ''
    },
    storeCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      config: {
        s3Host: '',
        s3Port: '',
        s3Bucket: '',
        s3Key: '',
        s3Secret: '',
        amqpHost: '',
        amqpPort: '',
        amqpVhost: '',
        amqpRouting: '',
        amqpStatusQueue: '',
        amqpMissionQueue: '',
        amqpExchangeMission: '',
        amqpId: '',
        amqpPw: '',
        amqpPrivkey: '',
        amqpCert: '',
        amqpCacert: '',
        storeCode: ''
      },
      amqpPrivkey: null,
      amqpCert: null,
      amqpCacert: null
    }
  },
  computed: {

  },
  async mounted () {
  },
  methods: {
    onAMQPCaCertFileChange (file) {
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.config.amqpCacert = e.target.result.split(',')[1]
        }
        reader.readAsDataURL(file)
      }
    },
    onAMQPCertFileChange (file) {
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.config.amqpCert = e.target.result.split(',')[1]
        }
        reader.readAsDataURL(file)
      }
    },
    onAMQPPrivkeyFileChange (file) {
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.config.amqpPrivkey = e.target.result.split(',')[1]
        }
        reader.readAsDataURL(file)
      }
    },
    closeModal () {
      this.$emit('closeDialog')
    },
    addRobotConfig () {
      const params = { store: this.storeCode }
      const config = { params }
      params.company = this.company
      this.config.storeCode = this.storeCode
      const msg = 'Loading...'
      EventBus.$emit('toggleLoadingModal', msg, true)
      this.$utils
        .callAxiosWithBody(
          codes.requests.postRobotCommonConfig.method,
          codes.requests.postRobotCommonConfig.url,
          { config: this.config },
          config
        )
        .then(res => {
          EventBus.$emit('toggleLoadingModal', msg, false)
          const result = res.data
          EventBus.$emit('messageAlert', this.$t(result.responseMessage))
          this.$emit('reloadRobotConfig')
        })
        .catch(error => {
          EventBus.$emit('toggleLoadingModal', msg, false)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
          console.debug(`Failed to add robot config. error: ${error}`)
        })
    }
  }
}
</script>
<style scoped>
::v-deep .form-file.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
  height: 100px !important;
}

.selection-v-select {
  position: absolute;
  top: 12px;
}

.selection-v-select-store {
  position: absolute;
}

.search-v-select {
  height: 46px;
  padding: 5px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
}

::v-deep .search-v-select>.v-input__control>.v-input__slot fieldset {
  border: 1px solid transparent !important;
}

::v-deep .customerSummary tr th span {
  display: block;
  white-space: break-spaces;
  word-break: break-word;
}

::v-deep .store-search .v-select__selections {
  height: 25px !important;
}

::v-deep .store-search>.v-input__control>.v-input__slot>.v-select__slot>.v-select__selections>input {
  height: 20px !important;
}

.v-btn.api-btns {
  pointer-events: none;
  width: 10px !important;
  height: 20px !important;
}
</style>
